/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserStreakResponse } from './UserStreakResponse';
import {
    UserStreakResponseFromJSON,
    UserStreakResponseFromJSONTyped,
    UserStreakResponseToJSON,
    UserStreakResponseToJSONTyped,
} from './UserStreakResponse';
import type { StreakConfigResponse } from './StreakConfigResponse';
import {
    StreakConfigResponseFromJSON,
    StreakConfigResponseFromJSONTyped,
    StreakConfigResponseToJSON,
    StreakConfigResponseToJSONTyped,
} from './StreakConfigResponse';

/**
 * 
 * @export
 * @interface StreakChallengeListEntry
 */
export interface StreakChallengeListEntry {
    /**
     * 
     * @type {StreakConfigResponse}
     * @memberof StreakChallengeListEntry
     */
    config: StreakConfigResponse;
    /**
     * 
     * @type {number}
     * @memberof StreakChallengeListEntry
     */
    participantCount: number;
    /**
     * 
     * @type {UserStreakResponse}
     * @memberof StreakChallengeListEntry
     */
    userStreak?: UserStreakResponse;
}

/**
 * Check if a given object implements the StreakChallengeListEntry interface.
 */
export function instanceOfStreakChallengeListEntry(value: object): value is StreakChallengeListEntry {
    if (!('config' in value) || value['config'] === undefined) return false;
    if (!('participantCount' in value) || value['participantCount'] === undefined) return false;
    return true;
}

export function StreakChallengeListEntryFromJSON(json: any): StreakChallengeListEntry {
    return StreakChallengeListEntryFromJSONTyped(json, false);
}

export function StreakChallengeListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakChallengeListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'config': StreakConfigResponseFromJSON(json['config']),
        'participantCount': json['participantCount'],
        'userStreak': json['userStreak'] == null ? undefined : UserStreakResponseFromJSON(json['userStreak']),
    };
}

export function StreakChallengeListEntryToJSON(json: any): StreakChallengeListEntry {
    return StreakChallengeListEntryToJSONTyped(json, false);
}

export function StreakChallengeListEntryToJSONTyped(value?: StreakChallengeListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'config': StreakConfigResponseToJSON(value['config']),
        'participantCount': value['participantCount'],
        'userStreak': UserStreakResponseToJSON(value['userStreak']),
    };
}

